<style lang="less" scoped>
  .destination-info-cover {
    margin-bottom: 34px;
    .destination-info-row {
      margin-bottom: 4px;
      > strong {
        margin-right: 5px;
      }
    }
  }

  .search-cover {
    width: 100%;
    max-width: 460px;
    .search-row {
      width: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      > strong {
        min-width: 80px;
      }
      .search-status-select,
      .search-num-input {
        width: 100%;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .present-col {
    padding: 0 !important;
    width: 100% !important;
  }

  .present-card-cover {
    margin-top: 20px;
  }
</style>

<template lang="pug">
  #orderDetail.admin-container
    .admin-title-cover
      .admin-title {{order.name}} {{order.created | date}}
      .admin-options-cover
        el-button(type="success" native-type="button" @click="submit") 저장
    .admin-content-cover
      .destination-info-cover
        .destination-info-row
          strong 주문자
          span {{order.name}} ({{order.phoneNumber}})
        .destination-info-row
          strong 주소
          span {{order.address}}
        .destination-info-row
          strong 전화
          span {{order.phoneNumber}}
        .destination-info-row
          strong 금액
          span {{order.totalPrice.toLocaleString()}}원 ({{order.receipt}})
      .search-cover
        .search-row
          strong 상태
          div
            el-select.search-status-select(v-model="status")
              el-option(
              v-for="type in listOfTypeSelect"
              :label="type.label"
              :value="type.value")
        .search-row(v-if="status === 'sent'")
          strong 송장번호
          div
            el-input.search-num-input(v-model="invoiceNumber")
      .present-card-cover
        .present-card-row
          present-card-component(
            v-for="prescription in order.prescriptions",
            :prescription="prescription")
</template>

<script>
import Happytree from '@/happytree';
import presentCardComponent from '@/components/present_card';
import moment from 'moment';

export default {
  data() {
    return {
      orderId: null,
      order: [],
      presents: [],
      listOfTypeSelect: [
        {
          label: '결제대기',
          value: Happytree.status.pending,
        },
        {
          label: '결제완료',
          value: Happytree.status.paid,
        },
        {
          label: '조제중',
          value: Happytree.status.inprogress,
        },
        {
          label: '발송완료',
          value: Happytree.status.sent,
        },
        {
          label: '취소됨',
          value: Happytree.status.canceled,
        },
      ],
      status: null,
      invoiceNumber: null,
    };
  },
  components: {
    presentCardComponent,
  },
  methods: {
    async submit() {
      const payload = {
        status: this.status,
        invoiceNumber: this.invoiceNumber,
      };
      if (this.status === Happytree.status.sent && !this.invoiceNumber) {
        alert('송장번호를 입력해주세요!');
        return;
      }
      try {
        await this.$http.put('/orders/'.concat(this.orderId), payload);
        alert('저장 완료!');
      } catch (e) {
        alert('저장에 실패하였습니다.');
      }
    },
  },
  async mounted() {
    this.orderId = this.$route.params.orderId;
    const { data } = await this.$http.get('/orders/'.concat(this.orderId));
    this.order = data;
    this.status = data.status;
  },
  filters: {
    date(value) {
      return moment(value).format('LLL');
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/admin/order_detail.vue